<template>
    <div>
        <form class="Lead-form">

            <h2 class="question-simu__title">Renseignez vos informations pour découvrir nos recommandations et vos aides</h2>

            <!-- prefix -->
            <form-wrapper :validator="$v.formValidations">
                <form-group name="prefix">
                    <div class="radio-field">
                        <input
                            type="radio"
                            id="prefix-monsieur"
                            name="prefix"
                            value="Monsieur"
                            required
                            v-model.trim="formValidations.prefix"
                            @input="$v.formValidations.prefix.$touch()"
                        />
                        <label for="prefix-monsieur">Monsieur</label>
                    </div>
                    <div class="radio-field">  
                        <input
                            type="radio"
                            id="prefix-madame"
                            name="prefix"
                            value="Madame"
                            required
                            v-model.trim="formValidations.prefix"
                            @input="$v.formValidations.prefix.$touch()"
                        />
                        <label for="prefix-madame">Madame</label>
                    </div>
                </form-group>
            </form-wrapper>
            
            <div class="grid-container grid-layout-2">
                <!-- LastName -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group 
                        name="lastname" 
                        class="inputField-simulator"
                    >
                        <div
                            class=""
                            :class="{ validate: !$v.formValidations.lastname.$invalid && $v.formValidations.lastname.$dirty }"
                        >
                            <input
                                type="text"
                                id="lastname"
                                name="lastname"
                                required
                                placeholder="Nom"
                                v-model.trim="formValidations.lastname"
                                @blur="$v.formValidations.lastname.$touch()"
                                @focus="$v.formValidations.lastname.$reset()"
                            />
                        </div>
                    </form-group>
                </form-wrapper>

                <!-- FirstName -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="firstname" class="inputField-simulator">
                        <div
                            class=""
                            :class="{ validate: !$v.formValidations.firstname.$invalid && $v.formValidations.firstname.$dirty }"
                        >
                            <input
                                type="text"
                                id="firstname"
                                name="firstname"
                                required
                                placeholder="Prénom"
                                v-model.trim="formValidations.firstname"
                                @blur="$v.formValidations.firstname.$touch()"
                                @focus="$v.formValidations.firstname.$reset()"
                            />
                        </div>
                    </form-group>
                </form-wrapper>
            </div>

            <div class="grid-container grid-layout-2">

                <!-- Postal Code -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="postalcode" class="inputField-simulator">
                        <div :class="{ validate: !$v.formValidations.postalcode.$invalid && $v.formValidations.postalcode.$dirty }">
                            <input
                                type="text"
                                id="postalcode"
                                name="postalcode"
                                maxlength="5"
                                placeholder="Votre code postal"
                                v-model.trim="formValidations.postalcode"
                                @input="unbounceValidation();handlePostalCodeValidity()"
                                required
                            />
                        </div>
                    </form-group>
                </form-wrapper>

                <!-- City -->
                <form-wrapper :validator="$v.formValidations" >
                    <form-group name="city" class="inputField-simulator">
                        <div :class="{ validate: !$v.formValidations.city.$invalid && $v.formValidations.city.$dirty }">
                            
                            <!-- Has cities choice -->
                            <select
                                v-if="hasCitiesSuggestion && isPostalCodeValid"
                                id="city"
                                name="city"
                                @change="updateSelectedCityDatas"
                                @blur="$v.formValidations.city.$touch()"
                                @focus="$v.formValidations.city.$reset()"
                                :disabled="!isPostalCodeValid"
                                required
                            >
                                <option class="placeholder" value="" selected disabled>Ville</option>
                                <option 
                                    v-for="(city, index) in suggestedCities" 
                                    :value="city.nom" 
                                    :id="value" 
                                    :key="index"
                                >
                                    {{city.nom}}
                                </option>
                            </select>

                            <!-- Has no cities suggestion (99999 postal code or api error) -->
                            <input
                                v-else
                                type="text"
                                id="city"
                                name="city"
                                v-model.trim="formValidations.city"
                                placeholder="Ville"
                                required
                                :disabled="!isPostalCodeValid"
                                @blur="$v.formValidations.city.$touch()"
                                @focus="$v.formValidations.city.$reset()"
                            />

                        </div>
                    </form-group>
                </form-wrapper>

            </div>

            <div class="grid-container grid-layout-1">
                <!-- Adresse -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="adresse" class="inputField-simulator">
                        <div class="autocomplete" ref="autocompleteContainer" :class="{ validate: !$v.formValidations.adresse.$invalid && $v.formValidations.adresse.$dirty }">             
                            <input
                                type="text"
                                id="adresse"
                                name="adresse"
                                :disabled="!selectedCityDatas.nom && hasCitiesSuggestion || !isPostalCodeValid"
                                placeholder="Numéro et rue du logement"
                                v-model.trim="formValidations.adresse"
                                @input="handleAutocompleteQuery"
                                @blur="$v.formValidations.adresse.$touch(); handleFocusAutocomplete(false)"
                                @focus="$v.formValidations.adresse.$reset(); handleFocusAutocomplete(true)"
                                required
                            />

                            <!-- Autocomplete suggestions -->
                            <ul 
                                v-if="adressesSuggestions.length > 0 && isAutocompletFocus"
                                class="autocompleteSuggestions"
                            >
                                <li 
                                    v-for="suggest in adressesSuggestions"
                                    class="autocompleteSuggest"
                                    :key="suggest.properties.id"
                                    @click="updateSelectedAdress(suggest.properties.name)"
                                >
                                    <p class="autocompleteSuggest__adress">{{suggest.properties.name}}</p>
                                    <p class="autocompleteSuggest__city"> - {{suggest.properties.city}}</p>
                                </li>
                            </ul>
                        </div>
                        
                    </form-group>
                </form-wrapper>
            </div>

            <div class="grid-container grid-layout-2">
                <!-- Phone -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="phone" class="inputField-simulator">
                        <div :class="{ validate: !$v.formValidations.phone.$invalid && $v.formValidations.phone.$dirty }">
                            <input
                                type="text"
                                id="phone"
                                name="phone"
                                maxlength="10"
                                placeholder="Téléphone"
                                v-model.trim="formValidations.phone"
                                @blur="$v.formValidations.phone.$touch()"
                                @focus="$v.formValidations.phone.$reset()"
                                required
                            />
                        </div>
                    </form-group>
                </form-wrapper>

                <!-- Email -->
                <form-wrapper :validator="$v.formValidations">
                    <form-group name="email" class="inputField-simulator">
                        <div 
                            :class="{ 
                                validate: !$v.formValidations.email.$invalid && $v.formValidations.email.$dirty && !(accountExist && isCurrentUserIsLoggedIn === false), 
                                error: accountExist && isCurrentUserIsLoggedIn === false}"
                        >
                            <input
                                type="email"
                                name="email"
                                id="email"
                                required
                                placeholder="Email"
                                v-model.trim="formValidations.email"
                                @input="validationEmail"
                            />
                        </div>
                        
                        <!-- Account exist -->
                        <div 
                            v-if="accountExist && isCurrentUserIsLoggedIn === false"
                            class="accountExist-connect" 
                        >
                            <p>Il semble que vous ayez déjà un compte</p>
                            <p><button @click.prevent="displayLoginModal(true)">connectez-vous</button> pour continuer</p>
                        </div>
                    </form-group>
                </form-wrapper>
            </div>

            <!-- Optin -->
            <form-wrapper :validator="$v.formValidations">
                <form-group name="proxiserve_optin">
                    <div class="checkbox-field">
                        <input 
                            type="checkbox" 
                            id="proxiserve_optin" 
                            name="proxiserve_optin"
                            v-model.trim="formValidations.proxiserve_optin"
                            @input="$v.formValidations.proxiserve_optin.$touch()"
                        >
                        <label for="proxiserve_optin">
                            J’accepte d’être recontacté par email ou téléphone par les équipe de Proxiserve dans le cadre de mon projet de remplacement de mes équipements de chauffage.
                        </label>
                    </div>
                </form-group>
            </form-wrapper>

            <!-- Login modal -->
            <transition name="slide-fade">
                <ModalLogin
                    v-if="showLoginModal"
                    :showModal="showLoginModal"
                    :class="'Modal-right'"
                    @LoginModal::close="displayLoginModal(false)"
                    :emailProps="formValidations.email"
                    :shouldReload="false"
                ></ModalLogin>
            </transition>

        </form>

        <div class="lead-actions_container">
            <McpWheelLoader
                v-if="displayLoader"
                :display="displayLoader"
                :fixed="false"
                wheelSize="50"
            />

            <ActionsButtons 
                v-if="!displayLoader"
                currentQuestionIndex="1"
                @primaryBtn::action="submitLeadForm"
                @secondBtn::action="backToTunnel"
            />
        </div>
        
    
    </div>
</template>

<script>
//import { required, email, helpers } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
//import { isOptinChecked } from "@/services/validations.js";
import verifyAccountMixin from "@/mixins/actions/account/verifyAccountMixin";
import formValidationMixin from "@/mixins/actions/validation/formValidationMixin";
import EventBus from "@/event-bus";
import axios from 'axios';

import ModalLogin from "@/components/Modal/ModalLogin.vue";
import ActionsButtons from '@/includes/Simulator/ActionsComponents/ActionsButtons.vue';
import McpWheelLoader from '@/components/Loaders/McpWheelLoader.vue';


export default {
    name: "LeadForm",

    mixins: [verifyAccountMixin, formValidationMixin],

    components: {
        ActionsButtons,
        ModalLogin,
        McpWheelLoader,
    },

    props: {
        formAnswer: {
            type: Object,
            default: {}
        }
    },

    computed: {
        ...mapGetters({ 
            isCurrentUserIsLoggedIn: "isCurrentUserIsLoggedIn",
            currentUserInfo: "getCurrentUserInfo",
            currentUserShippingInfo: "getCurrentUserShippingInfo",
            dwellingAnswers: "getDwellingStepAnswers",
        }),
    },

    data() {
        return {
            showLoginModal: false,
            displayLoader: false,
            formValidations: {
                prefix: this.formAnswer.prefix,
                firstname: this.formAnswer.firstname,
                lastname: this.formAnswer.lastname,   
                adresse: this.formAnswer.adresse,
                city: this.formAnswer.city,
                postalcode: this.formAnswer.postalcode,
                phone: this.formAnswer.phone,
                email: this.formAnswer.email,
                proxiserve_optin: false,
            },
            isPostalCodeValid: false,
            hasCitiesSuggestion: false,
            suggestedCities: {},
            selectedCityDatas: {},
            adressesSuggestions: [],
            isAutocompletFocus: false,
            unbounceValidationTimer: null,
        };
    },

    methods: {
        /**
         * Set each answer in store
         */
        setAnswers() {
            Object.keys(this.formValidations).forEach(key => {
                const answerDatas = {
                    key: key,
                    answer: this.formValidations[key],
                    form: 'lead'
                }

                this.setAnswerDatas(answerDatas);
            })
        },

        /**
         * Display error messages
         */
        displayErrorMessage() {
            Object.keys(this.formValidations).forEach(key => {
                if(this.$v.formValidations[`${key}`]) this.$v.formValidations[`${key}`].$touch();
            })
        },

        /**
         * Handle question depending energy label
         * @param {String} mcpDpe
         * @returns 
         */
        handleOverallRenovationQuestion(datas) {
            const dpeLabelsNotEligible     = ['F', 'G'];
            const isEligible               = !dpeLabelsNotEligible.includes(datas?.simulator_advanced.mcp_dpe);
            this.setMcpDpe(datas?.simulator_advanced.mcp_dpe);

            if(isEligible){
                EventBus.$emit('stepAction::validate', 'dwelling');
                EventBus.$emit('stepAction::current', 'save_energy');
            } else {
                this.$emit('LeadForm::dpeEligibility', {isEligible, question: datas?.question});
            }  
        },

        /**
         * Remove question and answer on back to LeadForm
         */
        resetOverallRenovationQuestion() {
            this.removeQuestionAndAnswer({questionKey:"mcp_overall_renovation", formName:"dwelling"})
        },
        

        /**
         * Submit
         */
        async submitLeadForm() {
            const inputsToCheck = ['prefix', 'firstname', 'lastname', 'postalcode', 'adresse', 'city', 'phone', 'email'];

            if( this.checkFormValidity(inputsToCheck) && !(this.accountExist && this.isCurrentUserIsLoggedIn === false)) { 
                try {
                    this.setAnswers();
                    EventBus.$emit('gtm-leadForm::push');
                    
                    this.displayLoader = true;

                    let response = await this.doSaveLead({step: '?step_number=1', saveLead: false});
                    this.handleOverallRenovationQuestion(response.data);
                    
                    this.displayLoader = false;
                    
                } catch(error) {
                    this.displayLoader = false;
                    console.error(error)
                    
                    this.$fire({
                        title: "Oups",
                        text: "Une erreur est survenu, veuillez réessayer plus tard",
                        type: "error",
                        timer: 1500,
                        position: "top-end",
                    });
                }
                
            } else {
                await this.displayErrorMessage()

                if(document.querySelectorAll('.form-error')[0]) {
                    window.scrollTo(0, document.querySelectorAll('.form-error')[0].getBoundingClientRect().top - 70)
                }
            }
        },

        /**
         * Back to questions Tunnel
         */
        backToTunnel() {
            this.$emit('LeadForm::backToTunnel');
        },

        /**
         * check format email
         * check if account already exist
         * @param {String} event
         */
        validationEmail(event){     
            this.checkEmailValidity(event)

            const isEmailValid = !this.$v.formValidations.email.$invalid;
            isEmailValid ? this.verifyAccountByEmail(event.target.value) : this.accountExist = false;
        },

        /**
         * Display login modal
         * @param {Boolean} boolean
         */
        displayLoginModal(boolean) {
            this.showLoginModal = boolean;
        },

        handlePostalCodeValidity() {
            if(!this.$v.formValidations.postalcode.$invalid) {
                this.getSuggestedCitiesData(this.formValidations.postalcode);
                this.isPostalCodeValid = true;
            } else if(this.$v.formValidations.postalcode.$invalid) {
                this.formValidations.city = '';
                this.$v.formValidations.city.$reset()
                this.suggestedCities = {};
                this.hasCitiesSuggestion = false;
                this.selectedCityDatas = {};
                this.formValidations.adresse = '';
                this.$v.formValidations.adresse.$reset();
                this.adressesSuggestions = [];
                this.isPostalCodeValid = false;
            }
        },

        /**
       * set typing delay before validation
       * (for postalcode question)
       */
        unbounceValidation() {
            if(this.unbounceValidationTimer) {
            this.$v.formValidations.postalcode.$reset();
            clearTimeout(this.unbounceValidationTimer);
            }

            this.unbounceValidationTimer =  setTimeout(()=>{ 
                                            this.$v.formValidations.postalcode.$touch()
                                            }, 1000);
        },


        /**
         * 
         *      AUTOCOMPLETE FUNCTIONS
         *      ToDo create mixin
         */
        /**
         * Get cities suggestion related to postalcode
         * @param {String} postalcode
         */
        async getSuggestedCitiesData(postalcode) {
            if(postalcode === '99999' || !postalcode) return
            
            try{
                let apiUrl = `https://geo.api.gouv.fr/communes?codePostal=${postalcode}&fields=nom,code,codesPostaux&format=json&geometry=centre`
                this.suggestedCities = (await axios.get(apiUrl)).data;
                this.hasCitiesSuggestion = this.suggestedCities.length > 0
            } catch (error) {
                this.hasCitiesSuggestion = false;
                console.error('error in getSuggestedCitiesData', error)
            }
        },

        /**
         * update city selected
         * @param {Event} event - input change event
         */
        updateSelectedCityDatas(event) {
            this.selectedCityDatas = this.suggestedCities.find(city => city.nom === event.target.value);
            
            this.formValidations.city = this.selectedCityDatas.nom;
        },

        /**
         * update adress selected
         * @param {String} adress
         */
        updateSelectedAdress(address) {
            this.formValidations.adresse = address;
        },

        /**
         * handle focus state to display suggestions
         * @param {Boolean} focusState
         * timeOut fix display none before click event to select adress
         */
        handleFocusAutocomplete(focusState) {
            let timer = setTimeout(() => {
                this.isAutocompletFocus = focusState;
                clearTimeout(timer)
            },250)
        },

        /**
         * Handle adress input value
         * @param {Event} event
         */
        handleAutocompleteQuery(event) {
            this.getAdressesSuggestion(event.target.value)
        },

        /**
         * Get adresses datas suggestion for autocomplete
         * @param {String} query
         */
        async getAdressesSuggestion(query) {        
            // Debounce api calls and avoid error less than 3 characters
            if(query.length <= 3 || query.length%2 !== 0 || !this.hasCitiesSuggestion) return;
            
            try {
                let apiUrl = `https://api-adresse.data.gouv.fr/search/?q=${query}&citycode=${this.selectedCityDatas.code}`
                this.adressesSuggestions = (await axios.get(apiUrl)).data.features;   
            } catch(error) {
                console.error('error in getAdressesSuggestion()', error)
            }
                 
        },

       ...mapActions([
            "setAnswerDatas",
            "doSaveLead",
            "setMcpDpe",
            "removeQuestionAndAnswer"
        ])
    },
    
    created() {
        this.fillInputWithValue(true);
        this.resetOverallRenovationQuestion();
    },       
    
    watch: {
        isCurrentUserIsLoggedIn() {
            this.fillInputWithValue(true)
        },
    },
}
</script>

<style lang="scss">
.Lead-form {
    margin-top: 75px;

    .form-group {
        padding-bottom: 35px;

        @include breakpoint(md) {
            padding-bottom: 25px;
        
            &.inputField-simulator input[type=text], 
            &.inputField-simulator input[type=number], 
            &.inputField-simulator input[type=email] {
                padding: 20px 30px;
                height: 60px;
            }
        }
    }

    .form-group.error {
        margin-bottom: 0;
    }

    .form-error {
        margin: 0;
        padding: 5px 10px;
        font-size: 12px;
        background: none;
    }

    .accountExist-connect {
        color: $c-mcp-red; 
        
        p:first-child {
            &::before {
                content: "\e912";
                margin-right: 8px;
                font-family: 'icomoon' !important;
                speak: none;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
            }
        }

        p:last-child {
            margin-left: 20px;
        }

        button {
            color: initial;
            font-family: $font-family-text-bold;
            text-decoration: underline;
        }
    }

    .lead-actions_container {
        position: relative;
    }

    //Autocomplete
    .form-group .autocomplete {
        position: relative;

        .autocompleteSuggestions {
            position: absolute;
            z-index: 10;
            left: 0;
            top: calc(100% - 5px);
            width: 100%;
            background: $color-white;
            border-left: 1px solid #d3d6d9;
            border-right: 1px solid #d3d6d9;
            border-bottom: 1px solid #d3d6d9;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            .autocompleteSuggest {
                display: flex;
                justify-content: space-between;
                padding: 10px 20px;
                font-style: italic;

                &__adress {
                    color: $color-blue-light;
                }

                &__city {
                    color: $c-grey-light;
                    font-size: 1.2rem;
                }

                &:hover {
                    cursor: pointer;
                    
                    .autocompleteSuggest__adress {
                      color: #224960;  
                    }
                }
            }
        }
    }
}

</style>